export const environment = {
  production: true,
  apiURL: 'https://lighthouse.staging.tltgrp.com/api',
  ltlTrackingServiceURL: 'https://ltl-service.staging.tltgrp.com',
  commodityServiceAPIURL: 'https://commodity-service.staging.tltgrp.com/api',
  graphQLURL: 'https://lighthouse.staging.tltgrp.com/api/graphql',
  ablyKey: 'CBunZA.JcfeWg:nqgaR2qUXbD9dWCqP90OyCLnDdHrqRddzfKt86EJ814',
  links: {
    nexus: 'https://nexus.staging.tltgrp.com/',
    itracker: 'https://itracker.staging.tltgrp.com/',
    reporting: 'https://reporting.staging.tltgrp.com/',
  },
  sso: {
    url: 'https://sso.staging.tltgrp.com/realms/master',
    clientId: 'app-lighthouse',
  },
  mapbox: {
    accessToken:
      'pk.eyJ1IjoidGlsdGdyb3VwIiwiYSI6ImNsbHh2dHl5bjJncnUza3RoZ2lkeHFkOHQifQ.gBgDAIq9VeKettrgqxdhdA',
    legacyMapBoxStyleUrl: 'mapbox://styles/tiltgroup/cm84dtnms003001s30mcia9y2',
    darkMapBoxStyleUrl: 'mapbox://styles/tiltgroup/cmrbsfvjn000501s720un0izv',
  },
  intercom: {
    appID: 'sqr4ikw7',
    secretKey: 'a489bVyoLYW1phSL33GqF_CmJYehHQIq4HNiP4lU',
  },
  agChart: {
    accessToken:
      'Using_this_{AG_Charts}_Enterprise_key_{AG-129526}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Innovate_AI_Solutions_LTD}_is_granted_a_{Multiple_Applications}_Developer_License_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts}_Enterprise_versions_released_before_{19_May_2027}____[v3]_[02]_MTgxMDY4MTIwMDAwMA==b208c7fb9b5fbffa724156a1a769d9fb',
  },
  cubeJS: {
    api: 'https://cubejs.staging.tltgrp.com/cubejs-api/v1',
  },
  pusher: {
    enabled: true,
    key: 'e8wXkhOHJcJJQetpVaGl',
    host: 'lighthouse-reverb.staging.tltgrp.com',
    port: 80,
    tlsPort: 443,
    forceTLS: true,
    authEndpoint:
      'https://lighthouse.staging.tltgrp.com/api/graphql/subscriptions/auth',
    presenceAuthEndpoint:
      'https://lighthouse.staging.tltgrp.com/api/broadcasting/auth',
  },
  graphQLEnumsURL: `https://lighthouse.staging.tltgrp.com/api/graphql-enums.json`,
  releaseNotesConfig: {
    project_key: '',
    base_url: 'https://release-manager.staging.tltgrp.com',
    token_mode: 'external',
  },
};
